import { jsxs, jsx } from 'react/jsx-runtime';
import { Modal } from '@phx-husky/modal';
var PromoModal = function PromoModal(_ref) {
  var children = _ref.children,
    isShowing = _ref.isShowing,
    close = _ref.close,
    closeModal = _ref.closeModal,
    disableOnClickClose = _ref.disableOnClickClose,
    title = _ref.title,
    closeAriaLabel = _ref.closeAriaLabel;
  return jsxs(Modal, Object.assign({
    isShowing: isShowing,
    close: close,
    disableOnClickClose: disableOnClickClose,
    className: "pp-modal"
  }, {
    children: [jsx("div", Object.assign({
      className: "pp-modal__close-button-container"
    }, {
      children: jsx("button", {
        className: "pp-modal__close-button",
        onClick: function onClick() {
          return closeModal();
        },
        type: "button",
        "aria-label": closeAriaLabel
      })
    })), title ? jsx("h3", Object.assign({
      className: "pp-modal__title"
    }, {
      children: title
    })) : null, jsx("div", Object.assign({
      className: "pp-modal__content"
    }, {
      children: children
    }))]
  }));
};
export { PromoModal };